import React, { useContext } from "react";
import { SiteContext } from "../context/SiteContext";
import { animationVersion, forcedAnimation } from "../util/animationVersion";
import PlaySorteo from "./PlaySorteo";
import PlaySorteoAnfora from "./PlaySorteoAnfora";

// Sorteo virtual: escenario 3D (PlaySorteo) solo en las salas que lo tengan habilitado; en las demás, la
// ánfora clásica. Mientras no se conoce la sala, PlaySorteo solo muestra la carga y no genera ningún sorteo.
export default function PlaySorteoBySala() {
  const { salaId } = useContext(SiteContext);
  const version = forcedAnimation() || (salaId == null ? "3d" : animationVersion(salaId));
  return version === "3d" ? <PlaySorteo /> : <PlaySorteoAnfora />;
}
